export default {
  welcome: 'Benvenuto',
  we_miss_you: 'Ci manchi',
  happy_friday: 'Buon venerdì',
  lazy_sunday: 'Domenica rilassante',
  loyalty_program: 'Programma fedeltà',
  you_might_also_like: 'Potrebbe interessarti anche',
  storefront_promo: 'Promo vetrina',
  welcome_members_club: 'Benvenuto nel club membri',
  launch_deal: 'Offerta di lancio',
};
